import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProfileCard from '../components/ProfileCard';
import blueImage from '../images/blue.png';
import greyImage from '../images/grey.png';
import redImage from '../images/red.png';
import yellowImage from '../images/yellow.png';
import './browse.css';

const Browse: React.FC = () => {
  const navigate = useNavigate();

  const profiles = [
    {
      name: "Recruiter",
      routeName: "recruiter",
      image: blueImage,
      backgroundGif: "/assets/backgrounds/background_2.gif",
      description: "View professional experience, skills, and resume - ideal for hiring managers"
    },
    {
      name: "Researcher",
      routeName: "researcher",
      image: greyImage,
      backgroundGif: "/assets/backgrounds/background_1.gif",
      description: "Explore technical projects, research work, and publications"
    },
    {
      name: "Stalker",
      routeName: "stalker",
      image: redImage,
      backgroundGif: "/assets/backgrounds/background_4.gif",
      description: "Quick access to contact info, resume, and professional details"
    },
    {
      name: "Explorer",
      routeName: "explorer",
      image: yellowImage,
      backgroundGif: "/assets/backgrounds/background_3.gif",
      description: "Discover interests, reading list, blogs, and personal insights"
    },
  ];

  const handleProfileClick = (profile: typeof profiles[0]) => {
    navigate(`/profile/${profile.routeName}`, {
      state: { profileImage: profile.image, backgroundGif: profile.backgroundGif }
    });
  };

  return (
    <main className="browse-container">
      <h1 className="visually-hidden">
        Choose Your Viewing Experience - Shivom Sharma Portfolio
      </h1>

      <p className='who-is-watching' role="heading" aria-level={2}>
        Who's Watching?
      </p>

      <p className="browse-subtitle visually-hidden">
        Select a profile to customize your portfolio viewing experience
      </p>

      <section
        className="profiles"
        role="list"
        aria-label="Profile selection options"
      >
        {profiles.map((profile, index) => (
          <ProfileCard
            key={index}
            name={profile.name}
            image={profile.image}
            description={profile.description}
            onClick={() => handleProfileClick(profile)}
          />
        ))}
      </section>

      <style>{`
        .visually-hidden {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>
    </main>
  );
};

export default Browse;
